// lib/consent.ts
export type ConsentState = {
  necessary: true;
  functional: boolean;
  analytics: boolean;
  marketing: boolean;
}

const COOKIE_NAME = 'cookie_consent';

export function getConsent(): ConsentState | null {
  if (typeof window === 'undefined') return null;
  
  const raw = document.cookie
    .split(";")
    .map(c => c.trim())
    .find((c) => c.startsWith(`${COOKIE_NAME}=`))
    ?.split("=")[1];
  
  if (!raw) return null;
  
  try {
    const parsed = JSON.parse(decodeURIComponent(raw));
    return {
      necessary: true,
      ...parsed
    };
  } catch (e) {
    return null;
  }
}

export function setConsent(state: Omit<ConsentState, 'necessary'>) {
  if (typeof window === 'undefined') return;
  const fullState: ConsentState = { necessary: true, ...state };
  const value = encodeURIComponent(JSON.stringify(fullState));
  // 1 year = 31536000 seconds
  document.cookie = `${COOKIE_NAME}=${value}; max-age=31536000; path=/; SameSite=Lax`;
}

export function hasConsented(): boolean {
  if (typeof window === 'undefined') return false;
  return document.cookie
    .split(";")
    .some((c) => c.trim().startsWith(`${COOKIE_NAME}=`));
}
